import Fuse from 'fuse.js'

window.fuse = Fuse;